import { PublicApiClient } from "../../apiClient/publicApiClient";
import { createStore } from "@stencil/store";
import { getEnvConfig } from "../../config";

export interface DocumentData {
    id: string;
    fileName: string;
    createdAt: string;
    mission: {
        sisMissionId: string;
        assignmentType: string;
    };
}

export interface DocumentType {
    id: string;
    fileName: string;
    createdAt: string;
    mission: {
        sisMissionId: string;
        assignmentType: string;
    };
    makeMissionLinkable: () => void;
    download: () => Promise<void>;
    store: { state: { isDownloading: boolean; downloadError: string | null } };
    apiClient?: PublicApiClient;
}

export class ServiceDocument implements DocumentType {
    id: string;
    fileName: string;
    createdAt: string;
    mission: {
        sisMissionId: string;
        assignmentType: string;
    };
    store = createStore<{
        isDownloading: boolean;
        downloadError: string | null;
        missionLink: string | null;
    }>({
        isDownloading: false,
        downloadError: null,
        missionLink: null
    });
    apiClient: PublicApiClient;
    private objectUrl: string | null = null;

    constructor({ id, fileName, createdAt, mission }: DocumentData, apiClient: PublicApiClient) {
        this.id = id;
        this.fileName = fileName;
        this.createdAt = createdAt;
        this.mission = mission;
        this.apiClient = apiClient;
    }

    async download(): Promise<void> {
        if (this.objectUrl) {
            window.open(this.objectUrl, "_blank");
            return;
        }
        try {
            this.store.state.isDownloading = true;
            this.store.state.downloadError = null;
            const response = await this.apiClient.request(`/document/downloaddocument`, {
                method: "POST",
                body: { documentId: this.id, fileName: this.fileName },
                responseType: "blob"
            });
            if (response) {
                const pdfBlob = new Blob([response], { type: "application/pdf" });
                this.objectUrl = URL.createObjectURL(pdfBlob);
                window.open(this.objectUrl, "_blank");
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log("Download error:", error);
            this.store.state.downloadError = "An error occurred while downloading the document.";
        } finally {
            this.store.state.isDownloading = false;
        }
    }

    makeMissionLinkable(): void {
        const config = getEnvConfig();
        this.store.state.missionLink = `${config.myTrumpfBaseUrl}/go/my-missions/mission/${this.mission.sisMissionId}`;
    }

    destroy(): void {
        if (this.objectUrl) {
            URL.revokeObjectURL(this.objectUrl);
            this.objectUrl = null;
        }
    }
}
